export const CANADIAN_POSTAL_CODE_REGEX =
  /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ ]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;

export const isValidPostalCode = (value: string): boolean => {
  if (!value) return false;
  return CANADIAN_POSTAL_CODE_REGEX.test(value.trim());
};

export const normalizePostalCode = (value: string): string => {
  if (!value) return value;
  const cleaned = value.trim().toUpperCase().replace(/[ -]/g, '');
  if (cleaned.length === 6) {
    return `${cleaned.slice(0, 3)} ${cleaned.slice(3)}`;
  }
  return cleaned;
};
